export const AgentStateEnum = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  DECOMMISSIONED: 'DECOMMISSIONED',
  DECOMMISSIONABLE: 'DECOMMISSIONABLE'
}

export const HostStatusEnum = {
  SAFE: 'safe',
  COMPROMISED: 'compromised',
  AT_RISK: 'at_risk',
  OFFLINE: 'offline',
  DECOMMISSIONED: 'decommissioned',
  DECOMMISSIONABLE: 'decommissionable',
  UNKNOWN: 'unknown',
  properties: {
    safe: {
      title: 'Safe',
      state: 'SAFE',
      color: 'rgb(23,159,255)'
    },
    compromised: {
      title: 'Compromised',
      state: 'COMPROMISED',
      color: 'rgb(255, 173, 173)'
    },
    at_risk: {
      title: 'At Risk',
      state: 'AT RISK',
      color: 'rgb(255, 173, 173)'
    },
    offline: {
      title: 'Offline',
      state: 'OFFLINE',
      color: 'rgb(206, 206, 206)'
    },
    decommissioned: {
      title: 'decommissioned',
      state: 'DECOMMISSIONED',
      color: 'rgb(206, 206, 206)'
    },
    decommissionable: {
      title: 'decommissionable',
      state: 'DECOMMISSIONABLE',
      color: 'rgb(206, 206, 206)'
    },
    unknown: {
      title: 'Unknown',
      state: 'UNKNOWN',
      color: 'rgb(211, 231, 255)'
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/host-status.constants.js